import { runDemo } from "../shared/demoRunner";
import { createMansionScene } from "./scene";

runDemo({ createScene: createMansionScene });
